import { getFormData } from 'utils/formData';

import { ApiService } from '../apiService';

// The backend picks the language from the `Language` request header
// (see apps.core.utils.get_request_language).
const langConfig = (language) => ({ headers: { Language: language } });

class Company extends ApiService {
  getAbout(language = 'hy') {
    return this.get('company/about/', {}, langConfig(language));
  }

  updateAbout(data) {
    return this.post('company/about/', getFormData(data));
  }

  getPrivacyPolicy(language = 'hy') {
    return this.get('company/privacy-policy/', {}, langConfig(language));
  }

  updatePrivacyPolicy(data) {
    return this.post('company/privacy-policy/', data);
  }

  getTermsOfUse(language = 'hy') {
    return this.get('company/terms-of-use/', {}, langConfig(language));
  }

  updateTermsOfUse(data) {
    return this.post('company/terms-of-use/', data);
  }

  getAccountDeletion(language = 'hy') {
    return this.get('company/account-deletion/', {}, langConfig(language));
  }
}

export default new Company();
